import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TextTitle } from '../../components/atoms';

const PaymentFailedScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-row justify-center items-center">
      <div
        className="flex justify-center items-center w-full flex-1 lg:w-1/2 min-h-screen px-6 lg:px-12 py-6 overflow-y-hidden bg-local bg-bottom bg-no-repeat bg-contain scrollbar-hidden"
        style={{
          backgroundImage: 'url(/img/bg1.png)'
        }}
      >
        <div className="flex flex-col gap-2 ">
          <div className="flex flex-col gap-14 w-full md:items-center pb-10 pr-0 md:pr-10 border-r-[0px]">
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-4">
                <TextTitle>{t('others.othPaymentFailed')}</TextTitle>

                <div className="flex w-full md:10/12"></div>
              </div>

              <div className="flex flex-row justify-end gap-4">
                <button
                  className="h-[40px] w-full md:w-[200px] bg-[#0C1FAA] text-white rounded hover:bg-[#0e1a73] text-sm"
                  onClick={() => navigate('/login')}
                >
                  {t('buttons.btnGoBack')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { PaymentFailedScreen };
